var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Debug from 'debug';
import EventEmitter from 'eventemitter3';
import Keycloak from 'keycloak-js';
var debug = Debug('authenticator');
var KeycloakAuthenticator = /** @class */ (function (_super) {
    __extends(KeycloakAuthenticator, _super);
    /**
     *
     * @param config
     * @param redirectUri
     * @param silentCheckSsoRedirectUri If provided, enable silent check sso with the provided uri,
     * see https://www.keycloak.org/docs/13.0/securing_apps/index.html#_javascript_adapter for more information.
     */
    function KeycloakAuthenticator(config, silentCheckSsoRedirectUri) {
        var _this = _super.call(this) || this;
        _this._initialized = false;
        _this._inst = Keycloak(config);
        _this._silentCheckSsoRedirectUri = silentCheckSsoRedirectUri;
        return _this;
    }
    Object.defineProperty(KeycloakAuthenticator.prototype, "user", {
        get: function () {
            return this._user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakAuthenticator.prototype, "token", {
        get: function () {
            return this._inst.token;
        },
        enumerable: false,
        configurable: true
    });
    KeycloakAuthenticator.prototype._getUser = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this._inst.idTokenParsed.preferred_username;
    };
    KeycloakAuthenticator.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var refreshed, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this._initialized) {
                            debug('already initialized');
                            return [2 /*return*/];
                        }
                        debug('initializing authenticator');
                        this._inst.onAuthSuccess = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this._user = this._getUser();
                                debug('authenticated as', this._user);
                                this.emit('userChanged', this._user);
                                return [2 /*return*/];
                            });
                        }); };
                        this._inst.onAuthLogout = function () {
                            debug('logout');
                            _this._user = undefined;
                            _this.emit('userChanged', null);
                        };
                        return [4 /*yield*/, this._inst.init({
                                onLoad: 'check-sso',
                                silentCheckSsoRedirectUri: this._silentCheckSsoRedirectUri,
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this._inst.updateToken(30)];
                    case 3:
                        refreshed = _b.sent();
                        refreshed && debug('token refreshed');
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        debug('token not refreshed');
                        return [3 /*break*/, 5];
                    case 5:
                        this._user = this._inst.tokenParsed && this._getUser();
                        this._initialized = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    KeycloakAuthenticator.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var refreshed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._initialized) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._inst.updateToken(5)];
                    case 1:
                        refreshed = _a.sent();
                        if (refreshed) {
                            this._user = this._getUser();
                            this.emit('tokenRefresh', null);
                        }
                        else {
                            debug('token not refreshed');
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    KeycloakAuthenticator.prototype.login = function (successRedirectUri) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._inst.login({
                            redirectUri: successRedirectUri,
                        })];
                    case 1:
                        _a.sent();
                        throw new Error('should not reach here');
                }
            });
        });
    };
    KeycloakAuthenticator.prototype.send_auth_obj = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._inst];
            });
        });
    };
    KeycloakAuthenticator.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._inst.logout()];
                    case 1:
                        _a.sent();
                        throw new Error('should not reach here');
                }
            });
        });
    };
    return KeycloakAuthenticator;
}(EventEmitter));
export { KeycloakAuthenticator };
export default KeycloakAuthenticator;
